import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-file-excel-2-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg font-bold text-background-50">
                VigorBuy<span className="text-primary-400">Spreadsheet</span>
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              The complete resource for VigorBuy Spreadsheet guides, templates, comparisons, and data management tips. Helping users organize products, prices, and orders efficiently.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-100 mb-4 uppercase tracking-wider">Quick Links</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">Home</Link>
              <Link to="/vigorbuy-spreadsheet-guide" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">Complete Guide</Link>
              <a href="#features" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">Features</a>
              <a href="#how-it-works" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">How It Works</a>
              <a href="#security" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">Security</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-100 mb-4 uppercase tracking-wider">Categories</h4>
            <div className="flex flex-col gap-2">
              {categories.slice(0, 7).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-100 mb-4 uppercase tracking-wider">More Categories</h4>
            <div className="flex flex-col gap-2">
              {categories.slice(7).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} VigorBuy Spreadsheet. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-background-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">Official Store</a>
            <Link to="/vigorbuy-spreadsheet-guide" className="text-xs text-background-500 hover:text-primary-400 transition-colors whitespace-nowrap">Guide</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}